import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Seo } from '../components/Seo';
import { landingContent } from '../content';
import type { Locale } from '../content/types';
import { getSeoConfig } from '../lib/seo';
import { AiSection } from '../sections/AiSection';
import { ContactSection } from '../sections/ContactSection';
import { ExperienceSection } from '../sections/ExperienceSection';
import { FaqSection } from '../sections/FaqSection';
import { HeroSection } from '../sections/HeroSection';
import { PackagesSection } from '../sections/PackagesSection';
import { ProcessSection } from '../sections/ProcessSection';
import { ServicesSection } from '../sections/ServicesSection';
import { TestimonialsSection } from '../sections/TestimonialsSection';
import { TrustBar } from '../sections/TrustBar';

type LandingPageProps = {
  locale: Locale;
};

export function LandingPage({ locale }: LandingPageProps) {
  const content = landingContent[locale];

  return (
    <>
      <Seo config={getSeoConfig('landing', locale)} />
      <Header locale={locale} />
      <main>
        <HeroSection content={content} />
        <TrustBar content={content} />
        <ServicesSection content={content} />
        <PackagesSection content={content} />
        <ProcessSection content={content} />
        <ExperienceSection content={content} />
        <AiSection content={content} />
        <TestimonialsSection content={content} />
        <FaqSection content={content} />
        <ContactSection content={content} />
      </main>
      <Footer locale={locale} />
    </>
  );
}
